<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="fab-transition"
    max-width="1000"
  >
    <v-card>
      <div class="d-flex justify-space-between mb-5" id="modal-header">
        <v-card-title class="py-3">사용자 업로드</v-card-title>
        <div class="mt-3 mr-2">
          <!-- <v-btn text>
            Upload With Classic
          </v-btn> -->
          <v-btn icon text @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-card-text
        v-if="!uploaded"
        class="d-flex flex-column align-center my-md-12 py-md-12 my-sm-8 py-sm-8 my-xs-0 py-xs-0 my-12 py-12"
      >
        <div v-if="!uploading" class="text-center">
          <div>
            <v-btn
              icon
              class="grey lighten-2 mb-4"
              style="height: 104px;width: 104px;"
              @click="selectFile"
              ><v-icon x-large class="grey--text text--darken-1"
                >mdi-upload</v-icon
              ></v-btn
            >
          </div>

          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="file"
            ref="provider"
          >
            <v-file-input
              @change="uploadVideo"
              v-model="selectedFile"
              accept="text/csv"
              placeholder="사용자 CSV 선택"
              prepend-icon="mdi-video"
              :error-messages="errors"
              ref="fileInput"
            ></v-file-input>
          </ValidationProvider>
          <v-btn
            :loading="submitLoading"
            type="submit"
            class="primary"
            depressed
            @click="submit()"
            >Submit</v-btn
          >
        </div>
      </v-card-text>
      <v-card-actions v-if="!uploaded">
        <p class="text-center grey--text caption px-12 px-xs-0">
        </p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserService from "@/services/UserService";
import CategoryService from "@/services/CategoryService";
export default {
  name: "UploadModal",
  props: ["openDialog"],
  data: function () {
    return {
      // dialog: this.openDialog ? this.openDialog : false,
      valid: false,
      uploaded: false,
      uploading: false,
      submitLoading: false,
      categoryLoading: false,
      interval: {},
      value: 0,
      show: false,
      rules: [
        (value) =>
          !value ||
          value.size > 5000000 ||
          `Video size should be less than 5 MB!, ${value.size}`,
      ],
      categoriesTitles: [],
      categories: [],
      visibility: [ { text: '전체공개', value: 'public' }, { text: '비공개', value: 'private'}],
      selectedFile: [],
      formData: {
        id: "",
        title: "",
        description: "",
        category: "",
        visibility: "",
      },
      imgDataUrl: "",
      url: "",
      headers: { Authorization: `Bearer ${this.$store.getters.getToken}` },
      csvData: ""
    };
  },
  computed: {
    dialog() {
      return this.openDialog;
    },
  },
  methods: {
    async uploadVideo(e) {
      const { valid } = await this.$refs.provider.validate(e);

      if (!valid) return;
      // console.log(this.selectedFile)

      this.formData.title = this.selectedFile.name;

      if (!this.selectedFile) {console.log("No File Chosen");}
      var reader = new FileReader();
      
      // Use the javascript reader object to load the contents
      // of the file in the v-model prop
      reader.readAsText(this.selectedFile);
      reader.onload = () => {
        this.csvData = reader.result;
      }
    },
    csvToJSON(csv_string){
      const rows = csv_string.split("\r\n");
      const jsonArray = [];
      const header = ["empno", "name", "department", "email", "position"]
    
      for(let i = 1; i < rows.length; i++){
        let obj = {};
        let row = rows[i].split(",");
        for(let j=0; j < header.length; j++){
          obj[header[j]] = row[j];
        }
        jsonArray.push(obj);
      }
      return jsonArray;
    },
    async submit() {
      const users = this.csvToJSON(this.csvData)

      const result = await UserService.updateUsers(users)
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitLoading = false;
          this.uploaded = false;
        });
      console.log("#result: ", result);

      this.closeModal();
    },
    async getCategories() {
      this.categoryLoading = true;
      const categories = await CategoryService.getAll()
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.categoryLoading = false));

      this.categoriesTitles = categories.data.data.map((category) => {
        return {
          _id: category._id,
          title: category.type === 'ecs'
            ? 'ECS Campus - ' + category.title
            : category.title
        }
      });
      this.categories = categories.data.data;
    },
    closeModal() {
      this.$emit("closeDialog");
    },
    selectFile() {
      this.$refs.fileInput.$refs.input.click();
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      console.log(field);
      this.imgDataUrl = imgDataUrl;
    },
  },
  mounted() {
    // this.getCategories();
  },
};
</script>

<style lang="scss">
#modal-header {
  border-bottom: 1px solid rgb(238, 232, 232);
}

#image-placeholder {
  padding-top: 8em;
  padding-bottom: 8em;
  border: 2px dashed rgb(209, 209, 209);
}
</style>
